import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import get from 'lodash.get';
import { useSelector } from 'react-redux';

import { DeprecatedTabButton } from 'ui-components/components/DEPRECATED/tabs/tab-button';
import { Text, TextType } from 'ui-components/components/text';

import { getReturnsPageBasePath, useIsEnhancedReturnsFeatureEnabled } from '../../store/returns/returns.helpers';
import Global from '../../store/global-selectors';
import style from './returns-status-tabs.module.less';

const renderSearchCountBadge = (count, isSelected) => {
  if (!count) {
    return null;
  }
  const classNames = classnames(style.badge, { [style.selected]: isSelected });
  return <Text className={classNames} textType={TextType.Caption} value={count} />;
};

const ReturnsStatusTabs = () => {
  const history = useHistory();
  const isEnhancedReturnsFeatureEnabled = useIsEnhancedReturnsFeatureEnabled();
  const historyPathname = history.location.pathname || '';
  const returnsPath = getReturnsPageBasePath(historyPathname, isEnhancedReturnsFeatureEnabled);
  const selectedTabId = useSelector(Global.selectReturnsNavSelectedViewId);
  const statusCountMap = useSelector(Global.selectReturnsNavStatusCountMap);

  const changeView = useCallback(
    (viewId) => {
      history.push(`${returnsPath}/${viewId}`);
    },
    [history, returnsPath],
  );

  return (
    <div className={style['returns-status-tabs']}>
      <DeprecatedTabButton onClick={() => changeView('outstanding')} selected={selectedTabId === 'outstanding'} theme='file-tab'>
        <FormattedMessage defaultMessage='Outstanding' description='returnStatusTabs.outstanding' id='WwSCXb' />
        {!!get(statusCountMap, 'outstanding') && renderSearchCountBadge(statusCountMap.outstanding, selectedTabId === 'outstanding')}
      </DeprecatedTabButton>
      <DeprecatedTabButton onClick={() => changeView('received')} selected={selectedTabId === 'received'} theme='file-tab'>
        <FormattedMessage defaultMessage='Received' description='returnStatusTabs.received' id='Rh5gck' />
        {!!get(statusCountMap, 'received') && renderSearchCountBadge(statusCountMap.received, selectedTabId === 'received')}
      </DeprecatedTabButton>
      <DeprecatedTabButton onClick={() => changeView('voided')} selected={selectedTabId === 'voided'} theme='file-tab'>
        <FormattedMessage defaultMessage='Voided' description='returnStatusTabs.voided' id='vU/Mxx' />
        {!!get(statusCountMap, 'voided') && renderSearchCountBadge(statusCountMap.voided, selectedTabId === 'voided')}
      </DeprecatedTabButton>
    </div>
  );
};
export default ReturnsStatusTabs;
